module.exports = __webpack_public_path__ + "img/icn_check_hv_kutsu.94ab5bc0.png";